import { Alert, Table } from '@pankod/refine-antd'
import dayjs from 'dayjs'
import React from 'react'

import useTableWithMeta from 'src/hooks/useTableWithMeta'
import { TLMSCommonError } from 'src/interfaces/common'

type ErrorLog = {
  id: string
  insertParticipantQueueId: string
  retryCount: number
  identifier: string
  identifierType: string
  programId: string
  payload: string
  authorId: string
  lastErr: string
  createdAt: string
  updatedAt: string
}

const ErrorLogsTableList = () => {
  const { tableProps } = useTableWithMeta<ErrorLog, TLMSCommonError, void>({
    dataProviderName: 'lms',
    resource: 'diklat/admin-pendaftaran/error-logs',
  })
  return (
    <div>
      <Alert
        showIcon
        type="info"
        message="Daftar error yang ditampilkan hanya dalam kurun waktu 1 bulan terakhir."
        className="!mb-3"
      />
      <Table
        {...tableProps}
        rowKey={'id'}
        tableLayout="fixed"
        scroll={{ x: 'max-content' }}
        size="small"
        expandable={{
          expandedRowRender: (record) => (
            <div>
              <p>
                <strong>Payload:</strong>
              </p>
              <pre className="!bg-gray-100 !p-3">
                {JSON.stringify(JSON.parse(record.payload), null, 2)}
              </pre>
            </div>
          ),
        }}
        columns={[
          { title: 'Identifier', dataIndex: 'identifier', width: 200 },
          { title: 'Identifier Type', dataIndex: 'identifierType', width: 130 },
          { title: 'Program ID', dataIndex: 'programId', width: 150 },
          { title: 'Error Reason', dataIndex: 'lastErr', width: 300 },
          { title: 'Author ID', dataIndex: 'authorId', width: 150 },
          {
            title: 'Uploaded At',
            dataIndex: 'createdAt',
            render: (value) => dayjs(value).format('DD MMM YYYY HH:mm:ss'),
            width: 150,
            fixed: 'right',
          },
        ]}
      />
    </div>
  )
}

export default ErrorLogsTableList
